<template>
  <div class="box">
    <Header title="库存查询"></Header>
    <div class="show-box">
      <div class="title-card">
        <div class="inquriy-box">
          <div class="inquriy-left">
            <img class="right-img" src="../assets/images/partInquriy1.png" alt />
          </div>
          <div class="inquriy-center">
            <van-search
              class="top-search"
              v-model="searchValue"
              shape="round"
              clearable
              left-icon
              placeholder="请输入零件关键字"
              background="none"
              @search="searchHandle"
            />
          </div>
          <div class="inquriy-right">
            <img
              class="right-img"
              src="../assets/images/search.png"
              alt
              @click="searchHandle"
            />
          </div>
        </div>
      </div>
      <div class="inquriy-list-box">
        <div class="notify-box" v-if="!inquriyShowFlag">
          <img class="notify-img" src="../assets/images/partInquriy2.png" alt />
        </div>
        <div class="list-box" v-if="inquriyShowFlag">
          <div class="noDataMsg" v-if="noData">没有找到相关零件信息</div>
          <div class="list-title" v-if="!noData">
            <div class="list-title-partNo">零件号</div>
            <div class="list-title-desc">零件名称</div>
            <div class="list-title-descCn">中文名称</div>
          </div>
          <van-list
            class="list-ul"
            finished-text="没有更多了"
            :finished="finished"
            v-model="loading"
            v-if="!noData"
            offset="10"
            @load="searchInquriy()"
          >
            <li
              class="list-li"
              v-for="(item, index)  in inquriyList"
              :key="index"
              @click="clickToPageDetail(item.id)"
            >
              <div class="list-partNo" v-text="item.id"></div>
              <div class="list-desc" v-text="item.name"></div>
              <div class="list-descCn" v-text="item.catalogDesc"></div>
            </li>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInquriy } from "@/api/partInquriy";
import { STATUS_CODE_OK } from "@/config";
import store from "@/store";
import { mapActions } from "vuex";
import Header from "@/components/Header";
export default {
  name: "partInquriy",
  data() {
    return {
      searchValue: "",
      pageNo: 0,
      displayCount: 8,
      inquriyShowFlag: false,
      loading: false,
      finished: false,
      refreshing: false,
      inquriyList: [],
      noData: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      if (from.fullPath && from.fullPath == '/partInquriyDetail') {
        if (store.getters.searchContent) {
          vm.searchValue = store.getters.searchContent;
          vm.searchHandle()
        }
      } else {
        vm.setSearchContent("");
      }
    })
  },
  methods: {
    // 查询数据
    async searchHandle() {
      this.setSearchContent(this.searchValue);
      this.finished = false;
      this.inquriyList = [];
      this.pageNo = 1;
      let { data } = await getInquriy({
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        name: this.searchValue,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.goodsBeans && data.goodsBeans.length < 1) {
          this.noData = true;
          this.finished = true;
        } else {
          for (var i = 0; i < data.goodsBeans.length; i++) {
            this.inquriyList.push(data.goodsBeans[i]);
          }
          this.noData = false;
          if (data.goodsBeans.length < this.displayCount) {
            this.finished = true;
          }
        }
        this.inquriyShowFlag = true;
      }
    },
    //滑动刷新
    async searchInquriy() {
      this.pageNo = this.pageNo + 1;
      let { data } = await getInquriy({
        pageNo: this.pageNo,
        displayCount: this.displayCount,
        name: this.searchValue,
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.goodsBeans && data.goodsBeans.length < 1) {
          this.finished = true;
          this.loading = false;
        } else {
          for (var i = 0; i < data.goodsBeans.length; i++) {
            this.inquriyList.push(data.goodsBeans[i]);
          }
        }
        if (data.goodsBeans.length < this.displayCount) {
          this.finished = true;
        }
      } else {
        this.finished = true;
      }
      this.loading = false;
    },
    //点击List数据跳转页面
    clickToPageDetail(id) {
      this.setPartNo(id);
      this.$router.push({
        name: "partInquriyDetail",
      });
    },
    ...mapActions(["setPartNo", "setSearchContent"]),
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .inquriy-box {
    display: flex;
    align-items: center;
    width: 100%;
    .inquriy-left {
      padding: 0px 0px 10px 20px;
      .right-img {
        width: 75px;
        height: 75px;
      }
    }
    .inquriy-center {
      padding: 0px 10px 0px 0px;
      width: -webkit-fill-available;
      .top-search {
        padding: 0px;
        .van-cell {
          padding: 0px 10px 0px 0px;
        }
        /deep/ .van-field__control {
          padding: 0px 15px;
        }
      }
    }
    .inquriy-right{
      padding: 6px 20px 0px 0px;
      .right-img {
        width: 50px;
        height: 50px;
      }
    }
    // .inquriy-right {
    //   height: 25px;
    //   line-height: 10px;
    //   width: 40px;
    //   padding: 2px 10px;
    //   color: #f2404d;
    //   border: 1px solid;
    //   border-radius: 8px;
    //   margin-right: 20px;
    //   background-color: #eeeeee;
    //   .van-icon {
    //     font-weight: bold;
    //     font-size: 20px;
    //   }
    // }
  }
  .inquriy-list-box {
    position: absolute;
    top: 120px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    padding: 0px 10px;
    .notify-box {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      .notify-img {
        max-width: 290px;
      }
    }
    .list-box {
      height: 100%;
      margin-top: 30px;
      .list-title {
        display: flex;
        height: 35px;
        // background: linear-gradient(to right, #da291c 60%, #f2404d);
        background: #da291c;
        border-radius: 20px 20px 0px 0px;
        padding: 0px 10px 0px 30px;
        align-items: center;
        text-align: left;
        font-size: 12px;
        color: white;
        .list-title-partNo {
          width: 29%;
        }
        .list-title-desc {
          width: 38%;
        }
        .list-title-descCn {
          width: 32%;
        }
      }
      .list-ul {
        border-radius: 0px 0px 20px 20px;
        font-size: 10px;
        margin-bottom: 20px;
        .list-li {
          display: flex;
          height: 50px;
          border-bottom: 1px solid #dcdcdc;
          align-items: center;
          text-align: left;
          padding: 0px 10px 0px 20px;
          margin: 0px 10px;
        }
        .list-partNo {
          width: 30%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-right: 15px;
          word-break: break-all;
        }
        .list-desc {
          padding-right: 15px;
          width: 40%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
        }
        .list-descCn {
          width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
        }
      }
    }
  }
}
</style>